/**
 * 考核内容编辑
 * @author wutao
 * @date 2020-08-31
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'dva';
import {Divider} from 'antd'
import {component_tool, framework_tool,utils_tool} from '@/tool'
import CommentDetailForm from './commentDetailForm';
import moment from "moment";
let {$$, checkStrLength } = utils_tool;
let {WizContainer} = framework_tool;
let {WizButton, WizModal, WizTable} = component_tool;

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}

class TrainPathCommentDetailList extends WizContainer {

  componentName = 'trainPathCommentDetailList';

  static propTypes = {
    value: PropTypes.array,
    maxSort:PropTypes.number,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value, //[{"key":1,"id":1,"name":"1","state":1},{"key":2,"id":2,"name":"2","state":0}],
      maxSort:props.maxSort,
      trainPathCommentId:props.trainPathCommentId,
      initMaxSort:props.maxSort,
      visible: false,
      item: undefined,
      date: new Date().getTime()

    };
    this.deleteKey;
  }

  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({value: nextProps.value});
    }
    if (this.props.maxSort !== nextProps.maxSort) {
      this.setState({maxSort: nextProps.maxSort});
    }
  }

  /**
   * 监控选择modal的返回值，并且将值反馈给Form
   */
  triggerChange = (nextTargetKeys) => {
    const {onChange} = this.props;
    this.setState({
      value: nextTargetKeys,
      date: new Date().getTime()
    });
    if (onChange) {
      onChange(nextTargetKeys);
    }
  };

  /**
   * 打开modal
   */
  changeVisible(visible) {
    this.setState({
      visible: visible,
      item: undefined,
      date: new Date().getTime()
    });
  };

  /**
   * 确定按钮
   */
  onSubmit = () => {
    const {onChange} = this.props;
    const {value} = this.state;
    this.setState({
      visible: false
    });
    if (onChange) {
      onChange(value);
    }
  };


  editRecord(record) {
    this.setState({
      visible: true,
      item: record,
      date: new Date().getTime()
    });
  }


  /** 行删除 */
  deleteRecord(record) {
    let {value,maxSort} = this.state;
    const {onChange} = this.props;
    const {sort} = record;
    let neoValue = Object.assign([]);
    if (record.id) {
      let content = "确认删除考核内容'" + record.head + "'吗？"
      WizModal.confirm({
        title: '注意', content,
        onOk: () => {
          this.deleteKey = record.key;
          for (let i = 0; i < value.length; i++) {
            if (value[i].key !== this.deleteKey) {
              if (sort && value[i].sort && value[i].sort>sort){
                value[i].sort = value[i].sort-1;
              }
              neoValue.push(value[i])
            }
          }
          let newMaxSort = neoValue.length;
          value = neoValue;
          this.setState({
            value: value,
            maxSort:newMaxSort,
            date: new Date().getTime()
          });
          if (onChange) {
            onChange(neoValue);
          }
          wizNotice.success('删除成功');
        },
        onCancel() {
        }
      });
    } else {
      for (let i = 0; i < value.length; i++) {
        if (value[i].key !== record.key) {
          if (sort && value[i].sort && value[i].sort>sort){
            value[i].sort = value[i].sort-1;
          }
          neoValue.push(value[i])
        }
      }
      let newMaxSort = neoValue.length;
      this.setValue(neoValue,newMaxSort);
      wizNotice.success('删除成功');
    }
  }

  /**上移下移 行数据 */
  moveUpAndDown(record) {
    const {value,maxSort} = this.state;
    if (value.length > 1) {
      let oldOrderNum = record.sort;
      let neoValue = Object.assign([])
      for (let i = 0; i < value.length; i++) {
        let entity = value[i]
        if (oldOrderNum == 1) { //首位下移
          if (i == 0) {
            entity.sort = 2;
          } else if (i == 1) {
            entity.sort = 1;
          }
        } else { //上移
          if (oldOrderNum == (i + 1)) {
            entity.sort = i;
          } else if (oldOrderNum == (i + 2)) {
            entity.sort = i + 2;
          }
        }
        neoValue.push(entity)
      }
      //重新排序
      neoValue.sort(function (a, b) {
        if (a['sort'] < b['sort']) {
          return -1
        }
        if (a['sort'] > b['sort']) {
          return 1
        }
        return 0;
      });
      this.setValue(neoValue,maxSort);
    }
  }

  propsAndStateOnChange = {

  };

  /** 改变行属性 */
  changeRecord(record) {
    let {value,maxSort} = this.state;
    let neoValue = Object.assign([], value);
    if (record.state == 1) {
      let content = "考核内容禁用后，学员评语考核内容将不再展示，确认禁用吗?"
      WizModal.confirm({
        title: '注意', content,
        onOk: () => {
          neoValue.forEach((value, index) => {
            if (value.key === record.key) {
              value.state = (value.state === 1 ? 0 : 1);
            }
          });
          this.setValue(neoValue,maxSort);
        },
        onCancel() {
        }
      });
    } else {
      neoValue.forEach((value, index) => {
        if (value.key === record.key) {
          value.state = (value.state === 1 ? 0 : 1);
        }
      });
      this.setValue(neoValue,maxSort);
    }
  }

  /**更新state并返回值给form */
  setValue(value,maxSort) {
    const {onChange} = this.props;
    this.setState(
      {value: value, visible: false, date: new Date().getTime(),maxSort},
      () => {
        if (onChange) {
          onChange(value);
        }
      }
    )
  }


  /**
   * 渲染列表
   */
  _renderList() {
    const {placeholder, ...otherProps} = this.props;
    const columns = [
      {
        title: '考核内容',
        dataIndex: 'head',
        key: 'head',
        width: 120
      },
      {
        title: '状态',
        dataIndex: 'state',
        key: 'state',
        dict: [
          {code: 1, codeName: '有效'},
          {code: 0, codeName: '无效'}
        ],
        width: 40,
        render: (text, record) => (
          <>{record.state == 1 ? "有" : "无"}效</>
        ),
      },
      {
        title: '最新修改时间',
        dataIndex: 'updateTime',
        key: 'updateTime',
        width: 100,
        render: (text, record) => (
          <>{ record && record.updateTime ? formatterDate(record.updateTime):formatterDate(new Date()) }</>
        ),
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 145,
        render: (text, record) => (
          <span>
            <a onClick={e => this.editRecord(record)}> 编辑 </a>
            <Divider type="vertical"/>
            <a onClick={e => this.changeRecord(record)}> {record.state == 1 ? '禁' : '启'}用</a>
            <Divider type="vertical"/>
            <a onClick={e => this.deleteRecord(record)} key={record.key + "delete"}>删除</a>
            <Divider type="vertical"/>
            <a onClick={e => this.moveUpAndDown(record)}> {record.sort == 1 ? '下' : '上'}移</a>
          </span>
        ),
      },
    ]
    return (
      <WizTable pagination={false} columns={columns} dataSource={this.state.value}/>
    )

  }

  /** 编辑考核内容数据处理 */
  addCommentDetail(item) {
    if (!item){
      item ={};
    }
    item.trainPathCommentId = this.state.trainPathCommentId;
    let {value} = this.state;
    let neoValue = Object.assign([], value);
    if (item && item.update) {
      if (item.tips) {
        let content = "考核内容禁用后，学员查看页面将不再展示该考核内容，确认禁用吗?"
        WizModal.confirm({
          title: '注意', content,
          onOk: () => {
            neoValue.forEach((data, index) => {
              if (data.key === item.key) {
                data.state = item.state;
                data.head = item.head;
                data.sort = item.sort;
                data.updateTime = item.updateTime;
              }
            });
            this.setValue(neoValue,this.state.maxSort);
          },
          onCancel() {
          }
        });
      } else {
        neoValue.forEach((data, index) => {
          if (data.key === item.key) {
            data.state = item.state;
            data.head = item.head;
            data.sort = item.sort;
            data.updateTime = item.updateTime;
          }
        });
        this.setValue(neoValue,this.state.maxSort);
      }
    } else {
      neoValue.push(item);
      let maxSort = item.sort;
      this.setValue(neoValue,maxSort);
    }
  }


  /**
   * 渲染modal框内的内容
   */
  _renderSelect() {
    return <CommentDetailForm key={'editListForm' + new Date().getTime()} commentDetailData={this.state.value}
                              addCommentDetail={this.addCommentDetail.bind(this)} item={this.state.item} maxSort={this.state.maxSort}/>
  }

  _render() {
    const {modal, placeholder, ...otherProps} = this.props;
    return (
      <>
        {this._renderList()}

        <WizModal
          className="antui-transfer-modal"
          title={'添加' + otherProps.title}
          visible={this.state && this.state.visible}
          width={600}
          footer={null}
          {...modal}
          onCancel={() => this.changeVisible(false)}
          maskClosable
        >
          {this._renderSelect()}
        </WizModal>
        <WizButton type="primary" onClick={() => this.changeVisible(true)}>添加</WizButton>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(TrainPathCommentDetailList);
